// **React Imports
import { memo, useCallback, useEffect, useState } from 'react'

// **MUI Imports
import { Button } from '@mui/material'

// **Utils Imports
import { showErrorToast } from '../../utils/utils'

// **API Imports
import { getAttemptRemark } from '../../axios/api/general'

// **Component Imports
import Icon from '../icon'
// import AddRemarkModal from './AddRemarkModal'
import ViewRemarkModal from './ViewRemarkModal'

const AddRemark = ({ attemptId }) => {
  // State
  const [data, setData] = useState('')
  // const [addModal, setAddModal] = useState(false)
  const [viewModal, setViewModal] = useState(false)

  // Handlers
  const fetchAttemptDetails = useCallback(async (attemptId) => {
    const response = await getAttemptRemark(attemptId)
    if (response?.isError) {
      showErrorToast(response)
    } else {
      setData(response)
    }
  }, [])

  // const handleAddModalChange = useCallback((value) => setAddModal(value), [])

  const handleViewModalChange = useCallback((value) => setViewModal(value), [])

  //useEffect
  useEffect(() => {
    if (attemptId) {
      fetchAttemptDetails(attemptId)
    }
  }, [attemptId, fetchAttemptDetails])

  return (
    <>
      {data?.length > 0 && (
        <Button
          variant="contained"
          className="editor-btn"
          startIcon={
            <Icon
              icon={'material-symbols:book-outline-rounded'}
              style={{ fontSize: '16px' }}
            />
          }
          onClick={() => handleViewModalChange(true)}
          sx={{ padding: '5px 10px', fontSize: '12px' }}
        >
          {'View Remarks'}
        </Button>
      )}
      {/* <Button
        variant="contained"
        startIcon={
          <Icon
            icon={'streamline:chat-bubble-square-write-remix'}
            style={{ fontSize: '14px' }}
          />
        }
        className="editor-btn"
        onClick={() => handleAddModalChange(true)}
        sx={{ padding: '5px 10px', fontSize: '12px' }}
      >
        {'Add Remark'}
      </Button>
      <AddRemarkModal
        open={addModal}
        attemptId={attemptId}
        refreshData={() => fetchAttemptDetails(attemptId)}
        handleClose={() => handleAddModalChange(false)}
      /> */}
      <ViewRemarkModal
        data={data}
        open={viewModal}
        handleClose={() => handleViewModalChange(false)}
      />
    </>
  )
}

export default memo(AddRemark)
